import { showToast } from "controls/global/stewart-toast";
import { setPolicyTransactionDeletedList } from "utils/api/policyTransactionApi";

// Soft-delete a single policy transaction via SetDeletedList, then toast the outcome.
export async function deletePolicyRecord(
  policyTransactionID: string,
  reason: string
): Promise<boolean> {
  const { success, errorMessage } = await setPolicyTransactionDeletedList({
    PolicyTransactionIDList: policyTransactionID,
    IsDeleted: true,
    Reason: reason,
  });
  showToast(
    success
      ? { type: "success", message: "Policy has been deleted" }
      : { type: "error", message: errorMessage || "Failed to delete the policy" }
  );
  return success;
}

export async function bulkDeletePolicyRecords(
  policyTransactionIDs: string[],
  reason: string
): Promise<boolean> {
  const n = policyTransactionIDs.length;
  const label = `${n} record${n !== 1 ? "s" : ""}`;
  const { success, errorMessage } = await setPolicyTransactionDeletedList({
    PolicyTransactionIDList: policyTransactionIDs.join(","),
    IsDeleted: true,
    Reason: reason,
  });
  showToast(
    success
      ? { type: "success", message: `${label} deleted` }
      : { type: "error", message: errorMessage || `Failed to delete ${label}` }
  );
  return success;
}

// Undo a soft delete (reuses the same proc with IsDeleted: false).
export async function restorePolicyRecords(
  policyTransactionIDs: string[],
  reason: string
): Promise<boolean> {
  const n = policyTransactionIDs.length;
  const label = `${n} record${n !== 1 ? "s" : ""}`;
  const { success, errorMessage } = await setPolicyTransactionDeletedList({
    PolicyTransactionIDList: policyTransactionIDs.join(","),
    IsDeleted: false,
    Reason: reason,
  });
  showToast(
    success
      ? { type: "success", message: `${label} restored` }
      : { type: "error", message: errorMessage || `Failed to restore ${label}` }
  );
  return success;
}
